<template>

  <vx-card :title="$t('live-class-schedule.schedule-detail')">

    <div class="vx-row mb-3">

      <div class="vx-col sm:w-1/2 w-full">
        <ValidationProvider :name="$t('live-class-schedule.topic-local')" rules="required"
                            v-slot="{ errors }">
          <label class="text-sm">{{$t('live-class-schedule.topic-local') + ' *'}}</label>
          <vs-input class="w-full" v-model="form.liveClassScheduleInput.topicLocal"/>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>

      <div class="vx-col sm:w-1/2 w-full">
        <label class="text-sm">{{$t('live-class-schedule.topic-eng')}}</label>
        <vs-input class="w-full" v-model="form.liveClassScheduleInput.topicEng"/>
      </div>

    </div>

    <div class="vx-row mb-3">

      <div class="vx-col sm:w-1/3 w-full">
        <ValidationProvider :name="$t('live-class-schedule.on-air-date')" rules="required" v-slot="{ errors }">
          <label class="text-sm">{{$t('live-class-schedule.on-air-date') + ' *'}}</label>
          <datepicker :disabledDates="disabledStartDates" :format="dateTimeFormat.yyyymmdd"
                      @input="onDateFromChange"
                      v-model="form.liveClassScheduleInput.dateTimeFrom"></datepicker>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>

      <div class="vx-col sm:w-1/3 w-full">
        <div class="vx-row">

          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.date-time-from')" rules="required" v-slot="{ errors }">
              <label class="text-sm">{{$t('live-class-schedule.date-time-from') + ' *'}}</label>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.date-time-from')" :options="liveClassScheduleEdit.hour"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="liveClassScheduleEdit.selectedHourFrom">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>

          </div>
          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.minute-from')" rules="required" v-slot="{ errors }">
              <br>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.minute-from')" :options="liveClassScheduleEdit.minute"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="liveClassScheduleEdit.selectedMinuteFrom">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

        </div>
      </div>

      <div class="vx-col sm:w-1/3 w-full">

        <div class="vx-row">

          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.date-time-to')" rules="required" v-slot="{ errors }">
              <label class="text-sm">{{$t('live-class-schedule.date-time-to') + ' *'}}</label>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.date-time-to')" :options="liveClassScheduleEdit.hour"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="liveClassScheduleEdit.selectedHourTo">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>

          </div>
          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.minute-to')" rules="required" v-slot="{ errors }">
              <br>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.minute-to')" :options="liveClassScheduleEdit.minute"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="liveClassScheduleEdit.selectedMinuteTo">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

        </div>
      </div>

    </div>

    <div class="vx-row mb-3">
      <vs-alert :active="showWaringDate" color="warning" icon="icon-alert-triangle" icon-pack="feather">
        {{ $t('live-class-schedule.warning-date') }}
      </vs-alert>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <label class="text-sm">{{$t('live-class-schedule.live-from')}}</label>
        <vs-input class="w-full" v-model="form.liveClassScheduleInput.liveFrom"/>
      </div>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <label class="text-sm">{{$t('live-class-schedule.external-link')}}</label>
        <vs-input class="w-full" v-model="form.liveClassScheduleInput.externalLink"/>
      </div>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <label class="text-sm">{{$t('live-class-schedule.external-password')}}</label>
        <vs-input class="w-full" v-model="form.liveClassScheduleInput.externalPassword"/>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label class="text-sm">{{$t('live-class-schedule.contract-info')}}</label>
        <vs-textarea rows="3" v-model="form.liveClassScheduleInput.contract"/>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label class="text-sm">{{$t('live-class-schedule.remark')}}</label>
        <vs-textarea rows="3" v-model="form.liveClassScheduleInput.remark"/>
      </div>
    </div>

  </vx-card>

</template>

<script>
  import {state} from '../data';
  import Datepicker from 'vuejs-datepicker';
  import vSelect from 'vue-select';
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format'


  export default {
    components: {
      vSelect,
      Datepicker,
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        dateTimeFormat: dateTimeFormat,

        classRoomEdit: state.local.classRoomEdit,
        liveClassScheduleEdit: state.local.liveClassScheduleEdit,
        form: state.local.liveClassScheduleEdit.form,

      }
    },
    computed: {
      disabledStartDates() {
        return {
          to: new Date(),
        };/*
        if (this.classRoomEdit.selectedClassRoom && this.classRoomEdit.selectedClassRoom.startDate) {

          let startDate = moment.utc(this.classRoomEdit.selectedClassRoom.startDate);
          let endDate = moment.utc(this.classRoomEdit.selectedClassRoom.endDate);

          return {
            from: new Date(endDate.year(), endDate.month(), endDate.date()),
            to: new Date(startDate.year(), startDate.month(), startDate.date()),
          };
        } else {
          return {
            to: new Date(),
          };
        }*/
      },
      showWaringDate() {
        return this.liveClassScheduleEdit.showWaringDate;
      }
    },
    watch: {
      liveClassScheduleProcessing(data) {
        this.local.isProcessing = data;
      },
      classRoomProcessing(data) {
        this.local.isProcessing = data;
      },
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
      classSectionProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//

      //---------------------------------------- Event Function ------------------------------------------------------//
      onDateFromChange() {
        this.form.liveClassScheduleInput.dateTimeTo = this.form.liveClassScheduleInput.dateTimeFrom;

        let selectedDate = moment(this.form.liveClassScheduleInput.dateTimeTo);
        this.liveClassScheduleEdit.selectedHourFrom = selectedDate.hour();
        this.liveClassScheduleEdit.selectedMinuteFrom = selectedDate.minute();
        this.liveClassScheduleEdit.selectedHourTo = selectedDate.hour();
        this.liveClassScheduleEdit.selectedMinuteTo = selectedDate.minute();
      },
      onTimeChange() {
        this.checkTime();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      checkTime() {
        let dateFrom = moment.utc(this.form.liveClassScheduleInput.dateTimeFrom);
        let dateTo = moment.utc(this.form.liveClassScheduleInput.dateTimeTo);

        dateFrom.set('hour', this.liveClassScheduleEdit.selectedHourFrom);
        dateFrom.set('minute', this.liveClassScheduleEdit.selectedMinuteFrom);
        dateTo.set('hour', this.liveClassScheduleEdit.selectedHourTo);
        dateTo.set('minute', this.liveClassScheduleEdit.selectedMinuteTo);

        this.liveClassScheduleEdit.showWaringDate = dateTo.isSameOrBefore(dateFrom);
      },
      async initData() {
        //set initial date time
        this.onDateFromChange();
      },
    },
    async mounted() {
      await this.initData();
    }
  }

</script>

<style scoped>

</style>
